import http from '../../../Services/api.laravel.http';

export const BranchService = {
    getSingleBranch: (id) => http.get('/admin/branch/' + id),
    ArchiveBranch: (formParams) =>
        http.post('/admin/branch/archives', formParams),
    branchPost: (formParams) => http.post('/admin/branch', formParams),
    paginateWithSearchBranches: (formParams) =>
        http.post('/admin/branch/search', formParams),
    updateSingleBranch: (formParams, id) =>
        http.put('/admin/branch/' + id, formParams),
    searchUser: (search) =>
        http.get('/admin/branch/search/user', { params: { search } }),
};
